<!--
 * @LastEditors: zhanglinju
-->
<template>
  <div>
    <div v-if="!showNodata">
      <bannerSwipe
        :list="bannerList"
        :site-id="siteid"
      />
      <keep-alive include="hometab">
        <hometab
          ref="tabs"
          :list="tabList"
          :cataloglist="catalogList"
          :site-id="siteid"
          @catalogDetail="catalogDetail"
        />
      </keep-alive>
      <lebals
        :showqq="showqq"
        :showdz="showdz"
      />
    </div>
    <div
      v-else
      class="nodata"
    >
      <img
        class="nodata_img"
        style="height:195px"
        src="../../../assets/image/icon_data_delete.png"
        alt=""
      >
      <span class="nodata_text">你访问的内容已被下架，暂无法浏览</span>
    </div>
  </div>
</template>

<script>
import hometab from './homeTabs';
import bannerSwipe from './bannerSwipe';
import lebals from './lebals';
import api from './proxy';
export default {
    name: 'Mobile',
    components: {
        hometab,
        bannerSwipe,
        lebals,
    },
    data () {
        return {
            showqq: false,
            showdz: false,
            code: null,
            bannerList: [],
            routerName: null,
            tabList: [],
            catalogList: [],
            siteid: null,
            shareData: {},
            showNodata: false,
            isPreview: false,
        };
    },
    watch: {
        shareData (nw) {
            console.log(this.$router.options.routes);
        },
    },
    created () {
        this.routerName = this.$route.name;
        this.code = this.$route.query.code;
        if (this.code) {
            this.isPreview = true;
            this.getCode();
            // this.getSite();
        } else {
            this.siteId = sessionStorage.getItem('urlSiteId') || this.$store.getters['system/getSiteList'][0].siteId;
            this.getcatalogList();
            this.getrotationInfoList();
            this.getPlug();
        }
        document.title = '优学派';
    },
    // 为div元素重新设置保存的scrollTop值
    beforeRouteEnter (to, from, next) {
        next(vm => { // vm = this
            console.log('jr');
            vm.$refs.tabs.setScrollTop();
        });
    },
    methods: {
        getSite () {
            let params = {
                code: this.code,
            };
            api.getSiteByCode(params).then(res => {
                if (res.errcode === 0) {
                    this.siteId = res.data.id.toString();
                    this.shareData = res.data;
                    this.showNodata = false;
                    document.title = res.data.name;
                    sessionStorage.setItem('urlSiteId', this.siteId);
                    this.wxshor();
                    this.getcatalogList();
                    this.getrotationInfoList();
                    this.getPlug();
                } else {
                    this.showNodata = true;
                }
            });
        },
        getCode () {
            let params = {
                code: this.code,
            };
            api.getSiteByCode(params).then(res => {
                if (res.errcode === 0) {
                    let data = res.data;
                    // 判断是否启用权限验证
                    /* if (data.isLogin === 1) {
                        this.$route.meta.disableValidation = false;
                        for (let index = 0; index < this.$router.options.routes.length; index++) {
                            if (index !== 0) {
                                this.$router.options.routes[index].meta.disableValidation = false;
                            }
                        }
                    } else {
                        this.$route.meta.disableValidation = true;
                        for (let index = 0; index < this.$router.options.routes.length; index++) {
                            if (index !== 0) {
                                this.$router.options.routes[index].meta.disableValidation = true;
                            }
                        }
                    } */
                    if (this.IsPC()) {
                        if (data.webTemplate) {
                            this.$router.replace({ name: 'webModulePage', query: this.$route.query });
                        } else if (data.h5Template) {
                            this.$router.replace({ name: 'mobileModules', query: this.$route.query });
                        }
                    } else {
                        if (data.h5Template) {
                            this.getSite();
                        } else if (data.webTemplate) {
                            this.$router.replace({ name: 'webModulePage', query: this.$route.query });
                        }
                    }
                } else {
                    this.showNodata = true;
                }
            });
        },
        IsPC () {
            var userAgentInfo = navigator.userAgent;
            var Agents = ['Android', 'iPhone',
                'SymbianOS', 'Windows Phone',
                'iPad', 'iPod'];
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
        },
        // 获取轮播图
        getrotationInfoList () {
            let params = {
                siteId: this.siteId,
            };
            api.getrotationInfoList(params).then((res) => {
                if (res.errcode === 0) {
                    this.bannerList = res.data.list;
                    console.log(this.bannerList);
                }
            });
        },
        // 获取tab
        getcatalogList () {
            let params = {
                siteId: this.siteId,
            };
            api.getcatalogList(params).then((res) => {
                if (res.errcode === 0) {
                    this.tabList = res.data.list;
                    this.catalogDetail(this.tabList[0].catalogId);
                    sessionStorage.setItem('catalogId', this.tabList[0].catalogId);
                }
            });
        },
        // 获取目录
        catalogDetail (id, index) {
            if (index !== undefined && this.tabList[index].type === 1) {
                if (this.routerName === 'mobileModules') {
                    this.$router.push({ name: 'mobileBoxContent', query: { url: this.tabList[index].catalogLink } });
                } else {
                    this.$router.push({ name: 'mobileContent', query: { url: this.tabList[index].catalogLink } });
                }
            } else {
                let params = {
                    siteId: this.siteId,
                    catalogId: id,
                    useScene: this.isPreview ? 1 : 0,
                };
                api.catalogDetail(params).then((res) => {
                    if (res.errcode === 0) {
                        let list = res.data.list;
                        list.forEach(e => {
                            if (e.image !== null) {
                                if (e.image.indexOf(';') !== -1) {
                                    e.image = e.image.slice(0, e.image.indexOf(';'));
                                }
                            }
                        });
                        list.sort(function (a, b) {
                            return a.rank - b.rank;
                        });
                        this.catalogList = list;
                    }
                });
            }
        },
        // 获取插件是否显示
        getPlug () {
            const params = {
                siteId: this.siteId,
            };
            api.getPageManagePlugList(params).then((res) => {
                if (res.errcode === 0) {
                    let tableData = res.data.list;
                    this.showqq = tableData[0].useType.includes('0');
                    this.showdz = tableData[1].useType.includes('0');
                }
            });
        },
        // 微信分享
        wxshor () {
            let that = this;
            // let url = 'https://market.anoah.com/product01/index.html#/'
            let url = location.href.split('#')[0];
            let params = {
                url: url,
            };
            api.getWxurl(params).then((res) => {
                let data = res.data;
                // eslint-disable-next-line no-undef
                wx.config({
                    debug: false, // 是否开启调试模式
                    appId: data.appId, // appid
                    timestamp: data.timestamp, // 时间戳
                    nonceStr: data.nonceStr, // 随机字符串
                    signature: data.signature, // 签名
                    jsApiList: [
                        'checkJsApi',
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareQZone',
                    ], // 需要使用的JS接口列表
                });
                // this.shareimg = that.shareData.logo;
                // if (this.shareimg == null) {
                //     this.shareimg = 'https://daogouapi.youxuepai.com/file/wechat/img/1125144501611YXPLOGO.png';
                // }
                // eslint-disable-next-line no-undef
                wx.ready(function () {
                    // eslint-disable-next-line no-undef
                    wx.onMenuShareAppMessage({
                        title: that.shareData.name || '优学派', // 分享标题
                        desc: that.shareData.description || '优学派', // 分享描述
                        link: window.location.href, // 分享链接
                        imgUrl: that.shareData.logo || 'https://daogouapi.youxuepai.com/file/wechat/img/1125144501611YXPLOGO.png', // 分享图标
                        success: function () {
                            console.log('分享成功');
                        },
                        cancel: function () {
                            console.log('分享失败');
                        },
                    });
                });
            });
        },
    },
};

</script>
<style lang="scss">
   .htmlBox{

  video{
      width: 90% !important;
      min-width: 90% !important;
      margin:0 auto!important;
    }
  }
</style>
<style lang='scss' scoped>
.nodata{
  // width: 50vh;
  height: 39vh;
  position: absolute;
  top: 30%;
  // left: 5%;
  img{
    width: 100%;
    height: 100%;
  }
}
.nodata_text{
    position: absolute;
    top: 90%;
    left: 22%;
  }
</style>
